"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
const _1 = require(".");
function default_1({ errorCode, setPaymentDetail, confirm, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const errorConfirm = (description) => (0, errors_1.alertConfirm)({ confirm, description });
        const updatePaymentDetail = () => __awaiter(this, void 0, void 0, function* () { return yield (0, _1.refetchPaymentDetail)({ setPaymentDetail }); });
        switch (errorCode) {
            case 40001: // ! 리더가 수정 막음
            case 40004: // ! 룸 판매완료 처리됨
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`${i18next_1.default.t('작가님 요청으로 수정할 수 없어요')}.`, (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('작가님께 문의해 주세요')} :)`] }));
                yield updatePaymentDetail();
                break;
            case 40005: // ! 환불 요청/승인 이력 있음
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('환불 요청하면 배송지를 변경할 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('작가님께 취소 문의해 주세요')} :)`] }));
                yield updatePaymentDetail();
                break;
            case 40007: // ! 판매자가 질문 설정 안함
            case 40008: // ! 판매자가 SNS 설정 안함
            case 40009: // ! 판매자가 개인통관 설정 안함
            case 40010: // ! 판매자가 환불계좌 수집 설정 안함
                errorConfirm(i18next_1.default.t('작가님께서 정보 수집을 취소하셨어요.'));
                yield updatePaymentDetail();
                break;
            case 40011: // ! 운송장이 입력되면 수정 불가능함
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`${i18next_1.default.t('운송장이 등록되면 수정할 수 없어요')}.`, (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('작가님께 문의해 주세요')} :)`] }));
                yield updatePaymentDetail();
                break;
            case 40014:
                errorConfirm((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('추가 배송비 발생하는 주소지로 변경할 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('작가님께 문의해 주세요')}!`] }));
                break;
            case 40015: // ! 연락처 20자 초과 (레거시 대응)
                errorConfirm(i18next_1.default.t('배송지 정보를 수정하고 다시 시도해 주세요!'));
                break;
            case 40002: // ! 환불 됨
            case 40003: // ! 무산/취소 판매자 룸
            case 40012: // ! 요청한 user_delivery_id 가 서버에 없음
                window.location.reload();
                break;
            case 40006: // ! 유효하지 않은 text 값
            case 40013: // ! 요청한 user_delivery 소유자가 아님
            default:
                (0, errors_1.commonErrorConfirm)({ confirm, errorCode });
        }
    });
}
exports.default = default_1;
